const advantagesSlider = {
    _sliderObject: null,

    init() {

        if(!document.querySelector('.js-advantages-slider')) {
            return;
        }

        let self = this;
        const scriptUrl = 'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js';

        window.initPackage(scriptUrl).then(() => {
            self._constructSlider();
        }).catch((error) => {
            console.error(error);
        });
    }, 


    //vytvoření jednotlivých sliderů
    _constructSlider() {
        let self = this;
                
        self._sliderObject = new Swiper('.js-advantages-slider', {
            direction: 'horizontal',
            loop: true,
            effect: 'slide',
            slidesPerView: 1,
            autoplay: {
                delay: 4000,
            },
            breakpoints: {

                576: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 4,
                },
            },
            
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        })
    },

    reInit() {
        let self = this;

        if(self._sliderObject) {
            self._sliderObject.destroy();
            self._sliderObject = null;
        }

        self.init();
    },
}

advantagesSlider.init();


document.addEventListener('LokiRequestEnd', function () {
    advantagesSlider.reInit();
});
